// extracted by mini-css-extract-plugin
module.exports = {"root":"BmiRanges_root__rgjuZ","ranges":"BmiRanges_ranges__3Df6L"};